<mat-chip-option
  id="chip-map-option"
  class="map-filter-chip"
  (click)="onClick()"
  [selectable]="selectable()"
  [aria-description]="ariaDescription()"
  [selected]="isSelected()"
  [disabled]="disabled()"
  #chipOption
  ><div class="chip-container">
    <span class="material-symbols-rounded">{{ chipIcon() }}</span>
    <span>{{ chipLabel() }}</span>
  </div></mat-chip-option
>
